import $ from 'jquery';
import 'jquery-migrate';

const $svjq = window.$svjq = window.jQuery = $.noConflict();

export default $svjq;